// VizbiPlus project timeline, migrated from legacy/Plus/Plus/timeline/index.shtml.
// `text` may contain trusted static HTML (links); images live in public/Plus/Timeline/.
export default [
  {year: "2015", date: "14 December", thumbnail: "IBS_small.png", image: "/Plus/img/IBS.png",
    caption: "The FODMAP Grand Tour Down Under: IBS relief",
    text: "Christopher Hammang together with Monash University premiered the animation: " +
      "<a href='https://youtu.be/Z_1Hzl9o5ic'>The FODMAP Grand Tour Down Under: IBS relief</a>."},
  {date: "20 July", thumbnail: "Conversation2-small.jpg", caption:
    "Second article in The Conversation",
    text: "Second article in The Conversation: <a href='https://theconversation.com/" +
      "art-and-science-combine-to-reveal-the-inner-workings-of-our-dna-44313'>Art and science " +
      "combine to reveal the inner workings of our DNA</a>"},
  {date: "June", thumbnail: "nat-bt2-small.jpg", caption:
    "Cover image commissioned by Nature Biotechnology",
    text: "Cover image for the journal <a href='https://www.nature.com/nbt/journal/v33/n6/" +
      "covers/index.html'>Nature Biotechnology Vol 33 No 6</a> (Nature Publishing Group, New " +
      "York, USA)."},
  {date: "April", thumbnail: "nat-bt1-small.jpg", caption:
    "Cover image commissioned by Nature Biotechnology",
    text: "Cover image for the journal <a href='https://www.nature.com/nbt/journal/v33/n4/" +
      "covers/index.html'>Nature Biotechnology Vol 33 No 4</a> (Nature Publishing Group, New " +
      "York, USA)."},
  {date: "30 March", text: "Invited talk on 'Biomedical animation with Blender', to prominent " +
    "structural biologists and visualisation experts (University of California San Francisco, " +
    "USA)."},
  {date: "26 March", text: "Organized the 'Art & Biology' evening as part of the VIZBI 2015 " +
    "(Cambridge, MA, USA)."},
  {date: "25 March", thumbnail: "alz-poster-small.jpg", caption:
    "Christopher Hammang's poster 'Alzheimer's Enigma'",
    text: "Presented poster <a href='/Posters/2015/B08'>Alzheimer's Enigma: Putting the Pieces " +
      "Together</a> at VIZBI 2015 (Cambridge, MA, USA)."},
  {date: "25 March", text: "Successfully awarded 2nd round of funding ($100,000) from CSIRO."},
  {date: "13 February", text: "One VizbiPlus animation was featured as part of an invited talk " +
    "at the Computational and Simulation Sciences and eResearch, Annual Conference 2015 " +
    "(Melbourne Convention Centre, Melbourne)."},
  {date: "4 February", thumbnail: "CanberraInvite-small.jpg",
    image: "/Showcase/2015/CanberraInvite-lg.jpg", caption:
      "Top: still from Christopher Hammang's 'Alzheimer's Enigma'; bottom: still from Maja " +
      "Divjak's 'The Insulin Receptor and Type 2 Diabetes'",
    text: "VizbiPlus Premiere 2015 (CSIRO Discovery Centre, Canberra) &mdash; the event was " +
      "streamed live and is available on <a href='https://youtu.be/DmKfS5gvyaU'>YouTube</a>. " +
      "<a href='/Showcase/2015/Invite4Feb2015.pdf'>Download the 2015 VizbiPlus Animation " +
      "Premiere brochure</a>."},
  {date: "4 February", text: "A VizbiPlus event was held for members of the national " +
    "government's Inspiring Australia team (Industry House, Canberra)."},
  {date: "January", thumbnail: "view-pearcey-small.jpg", caption:
    "Computer cluster at Canberra data centre",
    text: "VizbiPlus painting completed for Pearcey cluster at Canberra data centre."},
  {year: "2014", date: "26 November", text: "Invited keynote talk on 'Visualising Biological " +
    "Systems for Research and Outreach' at meeting titled 'Biological Data Visualization: " +
    "where science meets arts' (Ghent, Belgium)"},
  {date: "November", text: "Two VizbiPlus animations presented at invited talks in Munich and " +
    "Stuttgart (Germany)."},
  {date: "7 November", thumbnail: "vizzies-small.jpg", caption:
    "Finalists, video category, the Vizzies 2014",
    text: "Two VizbiPlus animations placed within the top ten for the National Science " +
      "Foundation 'Vizzies' 2014"},
  {date: "5 November", text: "Talk on 'Alzheimers murder mystery' at the Proteostasis " +
    "Symposium 2014 (University of Wollongong, Wollongong)."},
  {date: "28 October", text: "Two VizbiPlus animations presented at invited talk at Charles " +
    "Perkins Centre (University of Sydney, Sydney)."},
  {date: "16 September", text: "Two VizbiPlus animations shown as part of an invited plenary " +
    "talk to the International Conference on Systems Biology (Convention Centre, Melbourne)."},
  {date: "6 September &ndash; 8 November", thumbnail: "Chromatin-small.jpg", caption:
    "Scene from Kate Patterson's 'Epigenetics' animation",
    text: "Two videos featured in the “Body Image” exhibition at the UNSW Art/Design " +
      "Galleries"},
  {date: "30 May", thumbnail: "DGoodsell-portrait_small.jpg",
    image: "/Plus/Timeline/DGoodsell-portrait_large.jpg", caption: "David Goodsell",
    text: "Unlocking the Protein Data Bank: A Masterclass with David Goodsell (Museum of " +
      "Contemporary Art, Sydney)"},
  {date: "29 May", thumbnail: "vivid2014-small.jpg", caption:
    "'On Making Science Beautiful' featured David Goodsell's artwork and three new VizbiPlus " +
    "animations",
    text: "A second key event from the VizbiPlus team was <a href='/2014/Showcase'>On Making " +
      "Science Beautiful</a> (Museum of Contemporary Art, Sydney), co-organized with Vivid " +
      "Ideas as one of their Signature Events. This featured three new <a href='/Plus'>" +
      "VizbiPlus animations</a>, a talk from keynote speaker <a href='https://mgl.scripps.edu/" +
      "people/goodsell/'>David Goodsell</a>, and the unveiling of the inaugural VizbiPlus " +
      "Challenge finalists."},
  {date: "May", thumbnail: "Federation-Square-Big-Screen-2-small.jpg", caption:
    "Kate Patterson's 'Cancer Is Not One Disease' playing on the Big Screen in Melbourne's " +
    "Federation Square",
    text: "Three VizbiPlus animations shown on the Big Screen at Federation Square (Melbourne)."},
  {date: "17 April", thumbnail: "Conversation1-small.jpg", caption:
    "Article in The Conversation",
    text: "Article in The Conversation: <a href='https://theconversation.com/animating-life-" +
      "bringing-science-to-the-youtube-generation-25546'>Animating life: bringing science to " +
      "the YouTube generation</a>"},
  {date: "March", text: "Two VizbiPlus animations presented as part of talks at the " +
    "Computational and Simulation Sciences and eResearch, Annual Conference 2014 (Convention " +
    "Centre, Melbourne)."},
  {date: "6 March", thumbnail: "Microbiome-small.jpg", caption:
    "Poster, color and lighting study for 'The Hungry Microbiome'",
    text: "Presented poster <a href='/Posters/2014/Y21'>The Hungry Microbiome &mdash; colour " +
      "study</a> at VIZBI 2014 (Heidelberg, Germany)."},
  {year: "2013", date: "16 September", text: "One VizbiPlus animation shown as part of a talk " +
    "(<a href='https://www.youtube.com/watch?v=m2hMFrGBTLM'>available on YouTube</a>) for the " +
    "Big Data Crossover Evening event (Danish Design Center, Copenhagen, Denmark)."},
  {date: "2 September", text: "One VizbiPlus animation shown as part of an invited plenary " +
    "talk to the International Conference on Systems Biology (Tivoli Conference Center, " +
    "Copenhagen, Denmark)."},
  {date: "15 August", text: "VizbiPlus animations highlighted in Sydney University “Sydney " +
    "Ideas” seminar series."},
  {date: "30 June", thumbnail: "VIZBIplus-vividMay30-small.jpg", caption:
    "Vivid Ideas - Connect With Science",
    text: "The inaugural public event from the VizbiPlus team was <a href='/2013/Showcase'>" +
      "Connect with Science</a> (Museum of Contemporary Art, Sydney), co-organized with Vivid " +
      "Ideas as one of their Signature Events. This featured a keynote talk from <a href=" +
      "'https://vimeo.com/72709485'>Graham Johnson</a> (UCSF, USA), and an announcement of the " +
      "VizbiPlus project."},
  {date: "21 March", thumbnail: "Microbiome1-small.jpg", caption:
    "Poster 'The Hungry Microbiome' (early stage)",
    text: "Presented poster <a href='/Posters/2013/Y10'>The Hungry Microbiome</a> at VIZBI " +
      "2013 (Cambridge, MA, USA) &mdash; this poster won the Autodesk Award for Best Art &amp; " +
      "Biology submission, decided by popular vote."},
  {date: "29 January", text: "VizbiPlus kick-off meeting (Walter & Eliza Hall Institute, " +
    "Melbourne)."},
  {year: "2012", date: "1 May", text: "Successfully awarded 1st round of funding ($350,000) " +
    "from the Inspiring Australia team of the Australian government. This funding was matched " +
    "with in-kind contributions from the participating institutions for a total budget of " +
    "$1.2 million."},
  {date: "29 February", text: "Submitted initial proposal for VizbiPlus funding."}
];
